import React, { lazy, ComponentType, Suspense } from 'react';
import LoadingProgress from '@components/LoadingProgress';
import { useClientSpecificEventProvider } from '@hooks/clientSpecificUtils';
import { env } from 'env';
const EventScheduler = lazy(
  () => import('@features/EventScheduler/components/EventScheduler'),
);

const withMytaverseEventProviders = <T extends object>(
  WrappedComponent: ComponentType<T>,
) => {
  return (props: T) => {
    const clientSpecificEventProvider = useClientSpecificEventProvider();

    let Component = <WrappedComponent {...props} />;
    if (env.REACT_APP_FEATURE_EVENT_SCHEDULER === 'true') {
      Component = (
        <>
          <Suspense fallback={<LoadingProgress />}>
            <EventScheduler />
          </Suspense>
          <WrappedComponent {...(props as T)} />
        </>
      );
    }

    return clientSpecificEventProvider(Component);
  };
};
export default withMytaverseEventProviders;
